import { useState, useEffect } from "react";

function usePasswordValidation({ firstPassword = ""}) {
    const [validLength, setValidLength] = useState(false);
    const [hasNumber, setHasNumber] = useState(false);
    const [upperCase, setUpperCase] = useState(false);
    const [lowerCase, setLowerCase] = useState(false);
    const [specialChar, setSpecialChar] = useState(false);

    useEffect(() => {
        setValidLength(firstPassword.length >= 8 ? true : false);
        setUpperCase(firstPassword.toLowerCase() !== firstPassword);
        setLowerCase(firstPassword.toUpperCase() !== firstPassword);
        setHasNumber(/\d/.test(firstPassword));        
        setSpecialChar(/[ `!@#$%^&*()_+\-=\]{};':"\\|,.<>?~]/.test(firstPassword));
    }, [firstPassword]);

    return [validLength, hasNumber, upperCase, lowerCase, specialChar];
}

export default usePasswordValidation;